/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["button.btn-export[_ngcontent-%COMP%]{float:right;margin-bottom:30px;margin-right:10px;background-color:#182365!important}"];
export { styles as styles };
